import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  merge,
  switchMap
} from 'rxjs/operators';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { EnterpriseSearchService } from '@sabstravtech/obtservices/angular';

import { ChatWidgetInputBase } from '../chat-widget-input-base';

export interface ChatCarDetailsAnswer {
  carColour: string;
  carMake: string;
  carModel: string;
  registration: string;
}

@Component({
  selector: 'app-chat-car-details-input',
  standalone: false,
  templateUrl: './chat-car-details-input.component.html',
  styleUrls: ['./chat-car-details-input.component.scss']
})
export class ChatCarDetailsInputComponent extends ChatWidgetInputBase implements OnChanges {
  @Input() savedValue: Record<string, unknown> | null = null;
  @Input() required = false;
  @Output() answer = new EventEmitter<ChatCarDetailsAnswer>();
  @Output() skip = new EventEmitter<void>();

  carColour = '';
  carMake = '';
  carModel = '';
  registration = '';
  focus$ = new Subject<string>();
  chosenSummary: string | null = null;

  constructor(private searchService: EnterpriseSearchService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.onlyLockedChanged(changes)) {
      return;
    }
    // this.carCarrier = '';
    // this.carrierModel = null;
    // this.selectedCarrier = null;
    // const savedCarrier = this.savedValue?.['carCarrier'];
    // if (typeof savedCarrier === 'string' && savedCarrier.trim()) {
    //   const code = savedCarrier.trim().toUpperCase();
    //   this.carCarrier = code;
    //   this.selectedCarrier = { title: code, value: code };
    //   this.carrierModel = this.selectedCarrier;
    //   this.searchService
    //     .getAirlinesList(code)
    //     .pipe(catchError(() => of([])))
    //     .subscribe((airlines) => {
    //       const match = (airlines ?? []).find((airline) => airline.code === code);
    //       if (match && this.carCarrier === code) {
    //         this.selectedCarrier = { title: match.name, value: match.code };
    //         this.carrierModel = this.selectedCarrier;
    //         this.carCarrier = match.code;
    //       }
    //     });
    // }
    // this.carNumber =
    //   this.savedValue?.['carNumber'] != null ? String(this.savedValue['carNumber']) : '';
    this.chosenSummary = null;
  }

  get isValid(): boolean {
    return this.carColour && this.carMake && this.carModel && this.registration ? true : false;
  }

  onContinue(): void {
    if (this.locked || !this.isValid) {
      return;
    }
    this.chosenSummary = `Your car is a ${this.carColour} ${this.carMake} ${this.carModel} with registration number: ${this.registration}`;
    this.answer.emit({
      carColour: this.carColour,
      carMake: this.carMake,
      carModel: this.carModel,
      registration: this.registration
    });
  }

  onSkip(): void {
    if (this.locked || this.required) {
      return;
    }
    this.chosenSummary = 'Skipped';
    this.skip.emit();
  }
}
